import PropTypes from 'prop-types';
import React     from 'react';

export default function Alert({ icon = 'exclamation', type = 'info', children }) {
  const alertClassName = `alert alert--${type}`;
  const iconClassName  = `icons8 icons8-${icon}`;

  return (
    <div className={alertClassName}>
      <div className="alert__icon">
        <i className={iconClassName}></i>
      </div>
      <div className="alert__description">{children}</div>
    </div>
  );
}

Alert.propTypes = {
  icon:     PropTypes.string,
  type:     PropTypes.oneOf([ 'info', 'warn', 'error' ]),
  children: PropTypes.any.isRequired
};
